define('formkit/view/form/section/section.header.item.design.view',['require','exports','module','underscore','../../form.object/base.form.object.view','../../form.object/design.form.object.view','../../form.object/common/design.form.object.top.view','../../form.object/content/information.content.view','../../../behavior/bind.option.to.active.section.change.behavior'],function(require, exports, module) {
  var _                                       = require('underscore');
  var BaseFormObjectView                      = require('../../form.object/base.form.object.view');
  var DesignFormObjectView                    = require('../../form.object/design.form.object.view');
  var DesignFormObjectTopView                 = require('../../form.object/common/design.form.object.top.view');
  var InformationContentView                  = require('../../form.object/content/information.content.view');
  var BindOptionToActiveSectionChangeBehavior = require('../../../behavior/bind.option.to.active.section.change.behavior');

  var SectionHeaderTopView = DesignFormObjectTopView.extend({ });

  var SectionHeaderDesignView = DesignFormObjectView.extend({
    className: DesignFormObjectView.prototype.className + ' segment fitted basic sectionHeader',

    options: _.extend({}, DesignFormObjectView.prototype.options, {
      visible: true
    }),

    internalViewOptions: DesignFormObjectView.extendInternalViewOptions({
      topView: function() {
        return {
          type: SectionHeaderTopView,
          headerText: 'Section',
          canCopy: false,
          canDrag: false,
          canDoAdditionalActions: false,
          canCopyObeysMaxMultiplicity: false
        }
      },
      contentView: {
        type: InformationContentView,
        hasAnswer: false,
        disableLabelAndDescriptionInputFields: true
      }
    }),

    behaviors: {
      BindOptionToActiveSectionChangeBehavior: {
        behaviorClass: BindOptionToActiveSectionChangeBehavior,
        optionName: 'visible',
        valueWhenActive: true,
        valueWhenInactive: false
      }
    },

    getFormObjectContentViewType: function() {
      return;
    }
  });

  module.exports = SectionHeaderDesignView;
});

